import { createSelector } from "reselect";
import { isEmpty } from "lodash";

const defaultOptions = {
  images: true,
  phone: true,
  shortlist: true,
  like: true,
  expressInterest: true,
  rating: true,
  favourite: true,
  save: true,
  ignore: true,
  profileView: true,
  birthPlace: true,
  address: true,
  income: true,
  cache: true
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const privacy = state.user.privacy;
  if (isEmpty(privacy)) {
    return defaultOptions;
  }
  return privacy;
};
//VERIFY IF THE JWT IS SET
const getMyPrivacySetting = createSelector(getData, privacy => privacy);
export default getMyPrivacySetting;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyPrivacySetting.js